<script setup>
import { onMounted, onUpdated, ref, defineProps, computed } from "vue"
import { useTreeStore } from '@/store/modules/trees.js'
import { KNOLIA } from "../knolia"
import { Gems } from "../gems"
import TreeType from "@/enums/TreeType"
import { MESSAGES } from "../messages"
import { useDragAndDrop } from "../store/modules/drag-and-drop";

const dragAndDrop = useDragAndDrop()

const props = defineProps({
  element: { type: Object, required: true },
  metaId: { type: Number, required: true },
  columnDepth: { type: Number, required: true },
  isMeta: { type: Boolean },
  index: { type: Number, required: true },
  treeType: { type: Number, required: true },
})

const store = useTreeStore()
const showChilds = ref(false)
const dropZone = ref(null)
let showOptions = ref(false)

const designation = computed({
  get() {
    return props.element.designation
  },
  set(newValue) {
    Object.assign(props.element, {designation: newValue})
  }
})

function ChangeMetaOrElement() {
  Object.assign(props.element, {selected: !props.element.selected})
  
  if (props.isMeta == true) 
    store.setSelectedMeta(props.element.selected ? props.element : [])
  else
    store.FilterChildren([props.element, props.element.selected, props.metaId])
}

function OptionsHandler(status) {
  showOptions.value = status
  Object.assign(props.element, {editMode: status})
}

function ChangeInput(element) {
  if (!element.is_draggable && !props.isMeta || isKnowledge(element))
    return

  if(element.new)
    element.designation = ''

  OptionsHandler(true)
}

function isKnowledge(elem) {
  return elem.depth == 0 && elem.elem_id == 1 || props.metaId == 1
}

function ElementConfirm(e) {
  if(e.detail > 1)
    return
  
  OptionsHandler(false)
  store.UpdateElementName({
    name: props.element.designation,
    update: props.isMeta ? "meta" : "element",
    isMeta: props.isMeta,
    treeType: props.treeType,
    element: props.element
  })
  Object.assign(props.element, { currentDesignation: props.element.designation })
}

function ElementCancel() {
  if (props.element.new) {
    store.removeElementAndChilds(props.element)
  } else {
    OptionsHandler(false)
    Object.assign(props.element, { designation: props.element.currentDesignation })
  }
}

async function RemoveOpSkill(element) {
  if (element.is_op_skill) {
    await KNOLIA.CallBackEnd("post", "remove-skill-from-task", {
      element: element,
    })

    if((props.element.children.length - 1) == 0)
      showChilds.value = false

    store.UpdateTasksTree()
  }  
}

function Remove(element) {
  Gems.Telegram(MESSAGES.QUESTIONS.REMOVE_FROM_TREE, "tele-info", "", "tele-cancel")
    .then(
      async () => {
        if (element.is_activity || element.is_skill)
          element.relational_id = element.id

          await store.DissociateElement(element, props.treeType)

          if(props.isMeta && props.metaId == element.meta_id) 
            store.setSelectedMeta([])
      },
      () => {}
    );
}

async function CreateElem() {
  Object.assign(props.element, {children_count: props.element.children_count + 1})

  if (props.isMeta == true) {
    if(props.element.levels.length == 2) {
      if(props.element.levels[0].elements.length > 0) {
        document.getElementById(`new-column${props.element.levels[0].id}`)?.click()
        store.setSelectedMeta(props.element)
        return
      }
      else
        await store.NewColumn({meta: props.element, meta_id: props.element.meta_id, depth: parseInt(props.element.depth, 10) + 1, elements: [], treeType: props.treeType})
    }

    store.setSelectedMeta(props.element)
  }

  await KNOLIA.NewElem(store.insertChild, props.element)

  if(!props.element.selected)
    ChangeMetaOrElement()
}

function SetElementRowClass(element) {
  let openedRow = ''
  let rowTask = ''
  let draggable = ''
  let elementInactive = ''

  if(((element.is_skill || element.is_activity) && element.is_element_inactive) || element.is_parent_inactive)
    elementInactive = 'element-inactive'

  if(element.selected)
    openedRow = 'opened-row'

  if(element.is_task)
    rowTask = 'row-task'

  if(element.is_draggable)
    rowTask = 'draggable'

  if(showChilds.value)
    openedRow = 'opened-row task-children-opened'

  return `element-row default-radius ${elementInactive} ${openedRow} ${rowTask} ${draggable}`
}


function DefineDropFunction() {
  dragAndDrop.setDropFunction(async function () {
    if(props.element.new){
      Gems.Telegram('Elemento ainda não foi criado', 'tele-not-allowed')
      return
    }
    
    const draggedData = dragAndDrop.draggedData.element
    
    let continueToDrop = true
    if(draggedData.included && props.treeType == TreeType.SKILLS) {
      continueToDrop = await Gems.Telegram(MESSAGES.QUESTIONS.CONFIRM_NEW_TREE_DROP, 'tele-info', '', 'tele-cancel')
        .then(() => true, () => false)
    }
      
    if(continueToDrop) {
      if(props.treeType == TreeType.SKILLS)
        await store.DropElementInSkillsTree(draggedData, props.element)
      else 
        await store.DropElementInTasksTree(draggedData, props.element)
      
      if(store.ElemInserted) {
        if(!props.element.selected)
          document.getElementById(`checkbox${props.element.id}`).click()

        store.toggleElemInserted()
        
      }
    }

    
  }, dropZone.value)
}

function DefineDragFunction() {
  const elem = document.getElementById(`${props.element.designation + props.element.id}`)
  if(elem)
    dragAndDrop.setDragFunctionElem(function () {
      let checkDepth = props.element.totalDepth > 2 ? props.element.totalDepth - 2 : 1
      if (props.element.depth <= checkDepth) {
        dragAndDrop.setDraggedData({element: props.element})
      }
    }, elem) 
}

function assignElementData() {
  Object.assign(props.element, { selected: KNOLIA.ToBoolean(props.element.selected) })
  Object.assign(props.element, { is_op_skill: KNOLIA.ToBoolean(props.element.is_op_skill) })
  Object.assign(props.element, { is_draggable: KNOLIA.IsDraggable(props.element, props.columnDepth, showOptions.value) })
  Object.assign(props.element, { index: props.index})
}

function ChildHover(isHover) {
  if(props.element.is_task || props.element.is_op_skill)
    return

  const childGroupElement = document.getElementById(`parent-name${props.element.id}`)

  if(childGroupElement) {
    if(isHover) {
      childGroupElement.classList.add('highlight-child-parent-name')
      childGroupElement.parentElement.classList.add('highlight-child-group')
    } else {
      childGroupElement.classList.remove('highlight-child-parent-name')
      childGroupElement.parentElement.classList.remove('highlight-child-group')
    }
  }
}

function getElementId() {
  return !isKnowledge(props.element) ? `${props.element.designation + props.element.id}` : ''
}

onMounted(() => {
  assignElementData()

  store.setElementsTooltips(props.element)
  Object.assign(props.element, { currentDesignation: props.element.designation })

  DefineDragFunction()
  DefineDropFunction()
})

onUpdated(() => {
  assignElementData()

  store.setElementsTooltips(props.element)
  if(props.element.children && props.element.children.length == 0)
    showChilds.value = false

  DefineDragFunction()
  DefineDropFunction()
})

</script>

<template>
  <div class="div-depth-element" ref="dropZone" id="drop-zone">
    <div :class="SetElementRowClass(props.element)" :id="getElementId()"
      :draggable="props.element.is_draggable" @mouseenter="ChildHover(true)" @mouseleave="ChildHover(false)">

      <i class="fas cursor-pointer show-childs" :class="{'fa-plus': !element.selected, 'fa-minus': element.selected}" :id="`checkbox${props.element.id}`"
        v-show="(!props.element.is_task && !props.element.is_op_skill && props.element.children_count > 0) || props.isMeta"
        @click="ChangeMetaOrElement"></i>
        
      <div v-show="!props.element.is_task && !props.element.is_op_skill" class="checkbox-div"></div>

      <span v-if="!showOptions && !props.element.new" class="span-desig line-clamp line-clamp-1" @mouseenter="Gems.Tooltip($event.target, props.element.designation, 'tooltip')" @dblclick="ChangeInput(element)">
        {{ props.element.designation }}
      </span>

      <input v-else class="input input-line-clamp" v-model="designation" :title="props.element.designation" /> 

      <div class="div-menu-edit" v-show="showOptions || props.element.new">
        <i class="fa fa-check confirm" :id="`confirm-elem-name${element.id}`" @click="ElementConfirm($event)"></i>
        <i class="fa fa-times cancel" :id="`cancel-elem-name${element.id}`" @click="ElementCancel"></i>
      </div>

      <div class="element-std-icons">
        <i class="fa fa-plus-circle i-add-elem" :id="`new-elem${props.element.id}`"
          v-show=" !showOptions && !props.element.new && !isKnowledge(element) && (props.element.depth < props.element.totalDepth - 2 || props.isMeta)"
          @click="CreateElem()"></i>
  
        <i class="fa fa-trash remove-icon" :id="`delete-from-tree${props.element.id}`"
          v-if="!props.element.is_task && !props.element.new && !props.element.is_op_skill && !isKnowledge(element)"
          v-show="!showOptions && !props.element.new" @click="Remove(props.element)"></i>
  
        <i class="fa fa-list list-icon" :id="`skills-op${props.element.skill_id}`"
          v-if="props.element.is_task && !props.element.new && props.element.children.length > 0" @click="showChilds = !showChilds"></i>
      </div>
    </div>

    <div v-show="props.element.is_task && showChilds" class="element-children-list" :id="`div-skills-op${props.element.id}`">
      <div v-for="child of element.children" :key="child.id">
        <div class="div-tasks-children">
          <span class="line-clamp line-clamp-1">{{ child["designation"] }}</span>
          <i class="fas fa-times-circle cursor-pointer" :id="`delete-op-skill${child.id}`" @click="RemoveOpSkill(child)"></i>
        </div>
      </div>
    </div>
  </div>

</template>

<style scoped>
  @import './assets/styles/trees-style.css';

  .span-desig {
    width: 100%;
    padding: 0px 5px;
    line-height: 15px;
    font-size: .9em;
    text-align: left;
  }
</style>
